export default "__VITE_ASSET__CUSd84xo__"